import { render, staticRenderFns } from "./datamapper.vue?vue&type=template&id=5bc7825e&scoped=true&"
import script from "./datamapper.vue?vue&type=script&lang=js&"
export * from "./datamapper.vue?vue&type=script&lang=js&"
import style0 from "./datamapper.vue?vue&type=style&index=0&id=5bc7825e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7825e",
  null
  
)

export default component.exports